<div [class]="model.renderCssRoot" [innerHTML]="model.locHtml.renderedHtml | safeHtml" #contentElement></div>